export const products = [
  { 
    id: 'p1', 
    name: 'The Heritage Weekender', 
    price: 345, 
    category: 'bag', 
    image: 'https://images.unsplash.com/photo-1547949003-9792a18a2601?auto=format&fit=crop&q=80&w=800', 
    desc: 'Hand-cut from 6oz oil-tanned leather. Features solid brass hardware and a reinforced base for heavy-duty travel.', 
    isGiftIdea: false,
    badge: 'Limited Run'
  },
  { 
    id: 'p2', 
    name: 'Commuter Briefcase', 
    price: 285, 
    category: 'bag', 
    image: 'https://images.unsplash.com/photo-1548036328-c9fa89d128fa?auto=format&fit=crop&q=80&w=800', 
    desc: 'A slim, professional silhouette with internal padding for 16" laptops and external quick-access pockets.', 
    isGiftIdea: true,
    badge: 'Restocked'
  },
  { 
    id: 'p3', 
    name: 'Artisan Shopper Tote', 
    price: 195, 
    category: 'bag', 
    image: 'https://images.unsplash.com/photo-1590874103328-eac38a683ce7?auto=format&fit=crop&q=80&w=800', 
    desc: 'The essential daily companion. Unlined for a raw, natural feel that softens perfectly over time.', 
    isGiftIdea: false 
  },
  { 
    id: 'p4', 
    name: 'Classic Bifold Wallet', 
    price: 65, 
    category: 'wallet', 
    image: 'https://images.unsplash.com/photo-1627123424574-724758594e93?auto=format&fit=crop&q=80&w=800', 
    desc: 'Precision stitched with bonded nylon thread. Includes 6 card slots and a dedicated cash sleeve.', 
    isGiftIdea: true 
  },
  { 
    id: 'p5', 
    name: 'Minimalist Card Sleeve', 
    price: 45, 
    category: 'wallet', 
    image: 'https://images.unsplash.com/photo-1559563458-527698bf5295?auto=format&fit=crop&q=80&w=800', 
    desc: 'Designed for front-pocket carry. Holds up to 4 cards and folded bills with a low-profile footprint.', 
    isGiftIdea: true 
  },
  { 
    id: 'p6', 
    name: 'Anchor Brass Lanyard', 
    price: 25, 
    category: 'accessory', 
    image: 'https://images.unsplash.com/photo-1614252235316-8c857d38b5f4?auto=format&fit=crop&q=80&w=800', 
    desc: 'Solid sand-cast brass hardware paired with a vegetable-tanned leather strip for security.', 
    isGiftIdea: true 
  },
  { 
    id: 'p7', 
    name: 'Workshop Desk Mat', 
    price: 120, 
    category: 'accessory', 
    image: 'https://images.unsplash.com/photo-1589256469067-ea99122bbdc4?auto=format&fit=crop&q=80&w=800', 
    desc: 'Protect your workspace with a 24" x 14" premium leather surface that ages into a unique patina.', 
    isGiftIdea: false 
  },
  { 
    id: 'p8', 
    name: 'Field Notes Cover', 
    price: 55, 
    category: 'accessory', 
    image: 'https://images.unsplash.com/photo-1517842645767-c639042777db?auto=format&fit=crop&q=80&w=800', 
    desc: 'Includes an internal pen loop and sleeve for passports or small notebooks. Travel ready.', 
    isGiftIdea: true 
  },
];

export const reviews = [
  { id: 1, author: 'James W.', text: 'The Heritage Weekender exceeded all expectations. The leather smells incredible and the brass hardware feels indestructible.', rating: 5 },
  { id: 2, author: 'Sarah L.', text: 'I bought the tote as a gift for my husband. He carries it everywhere. The craftsmanship is truly world-class.', rating: 5 },
  { id: 3, author: 'Michael T.', text: 'My bifold wallet has developed the most amazing deep patina over the last six months of daily use.', rating: 5 },
];

export const supportData = {
  faq: [
    { q: 'Where are your products made?', a: 'Every Harbor & Hide piece is designed and handcrafted in our heritage workshop using traditional saddle-stitching techniques.' },
    { q: 'Will the leather stretch?', a: 'Full-grain leather has a natural give. Your wallet or bag will mold to your specific contents over the first 2-3 weeks of use.' },
    { q: 'Do you offer a workshop warranty?', a: 'Yes. We stand behind our work for life. If a stitch fails or hardware breaks, we will repair it in our workshop free of charge.' }
  ],
  care: [
    { title: 'Conditioning', text: 'Apply a high-quality beeswax-based leather balm every 6 months to maintain moisture and prevent surface cracking.' },
    { title: 'Water Resistance', text: 'If your goods get wet, wipe them with a dry cloth and let them air-dry naturally away from direct sunlight or radiators.' },
    { title: 'Aging & Patina', text: 'The darkening of the leather is a natural process caused by oils from your hands and UV exposure. It is the hallmark of quality.' }
  ],
  policies: [
    { title: 'Workshop Shipping', text: 'Free domestic shipping on orders over $150. International shipping is calculated at checkout based on weight.' },
    { title: 'Returns & Exchanges', text: 'We accept returns of unused items in original packaging within 30 days. Custom monograms are final sale.' }
  ]
};